import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import { JobApplication } from '../../types';
import ExternalJobsSubList from './ExternalJobsSubList';
import PastDivider from './PastDivider';

interface ExternalJobsListProps {
    // Future & current jobs
    currentFutureJobs: JobApplication[];
    isLoadingCurrentFuture: boolean;
    canLoadMoreCurrentFuture: boolean;
    onLoadMoreCurrentFuture: () => void;

    // Past jobs
    pastJobs: JobApplication[];
    isLoadingPast: boolean;
    canLoadMorePast: boolean;
    onLoadMorePast: () => void;
}

/**
 * Renders external jobs in two separate sections:
 * 1. Current/Future jobs (sorted desc by end date)
 * 2. Past jobs (sorted asc by end date)
 *
 * Each list has independent pagination and load more buttons.
 */
export default function ExternalJobsList({
    currentFutureJobs,
    isLoadingCurrentFuture,
    canLoadMoreCurrentFuture,
    onLoadMoreCurrentFuture,
    pastJobs,
    isLoadingPast,
    canLoadMorePast,
    onLoadMorePast
}: ExternalJobsListProps) {
    const hasCurrentFuture = currentFutureJobs.length > 0;
    const hasPast = pastJobs.length > 0;
    const isEmpty = !hasCurrentFuture && !hasPast && !isLoadingCurrentFuture && !isLoadingPast;

    if (isEmpty) {
        return null;
    }

    return (
        <Root>
            { hasCurrentFuture && (
                <ExternalJobsSubList
                    jobs={ currentFutureJobs }
                    canLoadMore={ canLoadMoreCurrentFuture }
                    onLoadMore={ onLoadMoreCurrentFuture }
                    isLoading={ isLoadingCurrentFuture }
                />
            ) }

            { hasCurrentFuture && hasPast && <PastDivider /> }

            { hasPast && (
                <ExternalJobsSubList
                    jobs={ pastJobs }
                    canLoadMore={ canLoadMorePast }
                    onLoadMore={ onLoadMorePast }
                    isLoading={ isLoadingPast }
                />
            ) }
        </Root>
    );
}

const Root = styled(Stack)(({ theme }) => ({
    rowGap: theme.spacing(3)
}));

